import { useRef } from 'react'
import { isEqual } from 'lodash'
import type { DependencyList, EffectCallback } from 'react'

type EffectHookType = (effect: EffectCallback, deps?: DependencyList) => void
type CreateDeepCompareEffectProps = (hook: EffectHookType) => EffectHookType

export const createDeepCompareEffect: CreateDeepCompareEffectProps =
  (hook) => (effect, deps) => {
    const ref = useRef<DependencyList>()
    const signalRef = useRef<number>(0)

    if (deps === undefined || !isEqual(deps, ref.current)) {
      signalRef.current += 1
    }

    ref.current = deps
    hook(effect, [signalRef.current])
  }
